import {
  calculateDisposition,
  type Context,
  type DispositionResult,
} from '@100mslive/disposition-engine';

import { PLACEHOLDERS } from './fieldMetadata';

export function projectTargetDisposition(
  workflowType: string,
  context: Context,
  missing: string[],
): DispositionResult {
  const projected: Context = { ...context };
  for (const field of missing) {
    projected[field] = PLACEHOLDERS[field] ?? '__filled__';
  }
  return calculateDisposition(workflowType, projected);
}
